// storageService.ts
import { Storage, Drivers } from '@ionic/storage';
import {
  KEY_PARENT_DETAILS,
  KEY_USER_DETAILS,
  KEY_USER_CHANGE_LANG,
  KEY_FIRE_REG_TOKEN,
  KEY_ACCESS_TOKEN,
  KEY_LOGIN_ACCESS_TOKEN,
} from './Helpers/constant';

const storage = new Storage({
  name: "__user",
  driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
});

storage.create();

export const getUserDetails = () => {
  const user = localStorage.getItem("userDetails");
  return user ? JSON.parse(user) : null;
};

export const getParentDetails = () => {
  const user = localStorage.getItem(KEY_PARENT_DETAILS);
  return user ? JSON.parse(user) : null;
};

export const getUserChangeLang = () => {
  const flag = localStorage.getItem(KEY_USER_CHANGE_LANG);
  return flag ? JSON.parse(flag) : null;
};

export const logOut = (config: any, history: any) => {
  localStorage.removeItem(KEY_FIRE_REG_TOKEN);
  localStorage.removeItem(KEY_USER_DETAILS);
  localStorage.removeItem(KEY_PARENT_DETAILS);
  localStorage.removeItem(KEY_LOGIN_ACCESS_TOKEN);
  sessionStorage.clear();
  localStorage.clear();
  history.push('/');
};

export const getAccessToken = () => {
  return localStorage.getItem(KEY_ACCESS_TOKEN);
};


export default storage;